/*
*###############################################################################
*Module Name                   : payment.js                                    #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Monday, June 13th 2022, 2:14:56 pm            #
*Copyright (c) 2022 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/
import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Label } from "reactstrap"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import DPAlert from "../../../framework/widgets/DPAlert"
import { Text, Numeric, DecimalValidation } from "../../../framework/validators/TextValidation" // Textbox input validations
import { GetSearchTable, PaymentObj } from "./TransactionController"
import { getPaymentModeByHedCode, getPaymentModeDetailByDetCode } from 'pages/Masters/PaymentModeHed/PaymentModeController';
import { Context } from "app-contexts/CommonContexts"
import { useContext } from 'react';



/**
    * @description This function is used to render the payment table.
    * @param {JSON} props - props of the table.
    * @returns {JSX} - JSX of the table.
 */

const Payment = ({
    DataRow,
    RemovePayRow,
    AddPayRow,
    Disabled,
    menuCode,
    PaidAmt,
    DueAmt,
    TotalPayCalculation,
    SetPayDataRow
}) => {
    const {
        isHeadOffice, menus, getMenuDetails, endOfDate, txnDecimalAmt
    } = useContext(Context);
    /**
        * @description This function is used to change the value of perticular field in perticular row.
        * @param {string} value - value of the row.
        * @param {string} id - id of the row.
        * @param {string} element - element of the row.
     */

    const changeRowValueChanges = (value, id, element) => {
        const objectIndex = DataRow.findIndex(obj => obj.id === id);
        const newObject = { ...DataRow[objectIndex], [element]: value };
        SetPayDataRow(prevDataRow => {
            const newDataRow = [...prevDataRow];
            newDataRow[objectIndex] = newObject;
            return newDataRow;
        });
    };

    /**
        * @description This function is used to change the value of complete row.
        * @param {JSON} row - row of the table.
        * @param {string} id - id of the row.
     */

    function handleObjectChange(row, id) {
        const objectIndex = DataRow.findIndex(obj => obj.id === id);
        SetPayDataRow(prevDataRow => {
            const newDataRow = [...prevDataRow];
            newDataRow[objectIndex] = row;
            return newDataRow;
        });
    }


    /**
        * @description This function is used to remove the perticular row.
        * @param {string} id - id of the row.
     */

    function RemoveRow(id) {

        var FilterByRowID = DataRow.filter((item) => item.id !== id);

        if (FilterByRowID.length === 0) { // If there is no rows in the table, add a new row.
            FilterByRowID.push({
                id: 1,
                Paycode: "",
                PayCodeDisable: false,
                Paydesc: "",
                PayDetcode: "",
                PayDetcodeDesable: true,
                PayDetName: "",
                PayAmount: 0,
                PayAmountDisable: true,
                AccountCode: "",
                AccountCodeDisable: true,
                ExpDate: "",
                ExpDateDisable: true,
                PayDetFormat: ""
            })
        }

        SetPayDataRow(FilterByRowID);

        TotalPayCalculation(FilterByRowID);

    }


    return (
        <React.Fragment>
            <Row>
                Payments
            </Row>
            <Row>
                <Col sm={12} md={12} className="mb-12-sm">
                    <table style={{ fontSize: "11px" }} id={"PaymentDet"}>
                        <thead className="table-light">
                            <tr>
                                <th>#</th>
                                <th style={{ textAlign: "left" }}>Payment code</th>
                                <th>&nbsp;</th>
                                <th style={{ textAlign: "left" }}>Payment Description </th>
                                <th style={{ textAlign: "left" }}>Detail Code</th>
                                <th>&nbsp;</th>
                                <th style={{ textAlign: "left" }}>Detail Name</th>
                                <th style={{ textAlign: "left" }}>Card/Cheque No</th>
                                <th style={{ textAlign: "left" }}>Cheque Date</th>
                                <th style={{ textAlign: "right" }}>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(DataRow).map((formRow, key) => (
                                <TableRemRow
                                    FormRow={formRow}
                                    Key={key}
                                    RemoveRow={RemoveRow}
                                    Disabled={Disabled}
                                    menuCode={menuCode}
                                    TotalPayCalculation={TotalPayCalculation}
                                    changeRowValueChanges={changeRowValueChanges}
                                    PaymentDetails={DataRow}
                                    handleObjectChange={handleObjectChange}
                                    txnDecimalAmt={txnDecimalAmt}
                                />
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={8}></td>
                                <td >Paid Amount</td>
                                <td style={{ textAlign: "right" }}>{

                                    parseFloat(PaidAmt).toLocaleString('en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: txnDecimalAmt,
                                    })

                                }</td>
                            </tr>
                            <tr>
                                <td colSpan={8}></td>
                                <td>Due Amount</td>
                                <td style={{ textAlign: "right" }}>{
                                    parseFloat(DueAmt).toLocaleString('en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: txnDecimalAmt,
                                    })
                                }</td>
                            </tr>
                        </tfoot>
                    </table>

                </Col>
            </Row>
            <Row>
                <Col sm={12} md={12} className="mb-12-sm" style={{ marginLeft: '13px' }}>
                    <Button
                        onClick={() => {
                            AddPayRow()
                        }}
                        disabled={Disabled}
                        color="success"
                        className="mt-1"
                        size="sm"
                    >
                        <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
                    </Button>
                </Col>
            </Row>
            <br />
        </React.Fragment>
    );
}

export default Payment;

const TableRemRow = ({ FormRow, Key, RemoveRow, Disabled, menuCode, TotalPayCalculation, changeRowValueChanges, PaymentDetails, handleObjectChange, txnDecimalAmt }) => {

    const ApiURL = window.Links.ApiURL

    useEffect(() => {
        SetGroupFilter("a")
    }, [FormRow]);

    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [groupFilter, SetGroupFilter] = useState("a")
    const [modal_xlargePay, setmodal_xlargePay] = useState(false)
    const [modal_xlargePayDet, setmodal_xlargePayDet] = useState(false)

    function tog_xlargePay() {
        setmodal_xlargePay(!modal_xlargePay)
    }
    function tog_xlargePayDet() {
        setmodal_xlargePayDet(!modal_xlargePayDet)
    }

    const clickPaySearch = async () => {
        tog_xlargePay()
    }
    const clickPaySearchDet = async () => {
        tog_xlargePayDet()
    }


    function CheckAccountNoLenth(PayDetcode, Accountno) {

    }

    /**
        *This function is used to check the payment code is already exist or not
        * @param {string} PayCode - Payment code
        * @param {string} id - Row id
        * @param {string} onclickCheck - 0 - when click on the row, 1 - when click on the search button
     */

    const CodeValidation = (PayCode, id, onclickCheck = 0) => {

        if (onclickCheck == 1) {
            for (let i = 0; i < PaymentDetails.length; i++) {
                const FilteredPayCode = PaymentDetails.filter((item) => item.Paycode == PayCode)
                if (FilteredPayCode.length >= 1) {
                    return false
                }
                return true
            }
        } else {
            for (let i = 0; i < PaymentDetails.length; i++) {
                const FilteredPayCode = PaymentDetails.filter((item) => item.Paycode == PayCode)
                if (FilteredPayCode.length > 1) {
                    return false
                }
                return true
            }
        }
    }

    /**
        *This function is used to get the payment mode details
        * @param {string} payModeCode - Payment mode code
        * @returns {object} - Payment mode details
        * If the payment mode is invalid or inactive, it will return an empty object
        * If the payment mode is valid and active, it will return the payment mode details
     */

    const GetPaymodeDetails = async (payModeCode) => {

        if (payModeCode == "") return

        const response = await getPaymentModeByHedCode(payModeCode)

        if (response.length == 0) {
            setAlertDescription("This payment mode is invalid. Please select another payment mode.")
            setAlertConfirmOption(4)
            setsweetAlertShow(true)
            changeRowValueChanges("", FormRow.id, "Paycode")
            return
        }

        if (response[0].pH_STATUS == 0) {
            setAlertDescription("This payment mode is inactive. Please select another payment mode.")
            setAlertConfirmOption(4)
            setsweetAlertShow(true)
            changeRowValueChanges("", FormRow.id, "Paycode")
            return
        }

        const currentRow = FormRow // get the current row data from the FormRow 
        SetGroupFilter(` AND PD_PHCODE = '${response[0].pH_CODE}' `)
        currentRow.Paycode = response[0].pH_CODE
        currentRow.Paydesc = response[0].pH_DESC
        currentRow.PayCodeDisable = true
        currentRow.PayDetcodeDesable = response[0].pH_DETAILS == 1 ? false : true
        currentRow.AccountCodeDisable = response[0].pH_DETAILS == 1 ? false : true
        currentRow.ExpDateDisable = true
        currentRow.PayAmountDisable = response[0].pH_DETAILS == 1 ? true : false
        handleObjectChange(currentRow, FormRow.id)
    }


    const GetPaymodeHedDetails = async (payModeHedCode) => {

        if (payModeHedCode == "") return

        const response = await getPaymentModeDetailByDetCode(payModeHedCode)

        if (response.length == 0) {
            setAlertDescription("This payment mode detail is invalid. Please select another payment mode detail.")
            setAlertConfirmOption(4)
            setsweetAlertShow(true)
            changeRowValueChanges("", FormRow.id, "PayDetcode")
            return
        }

        const currentRow = FormRow // get the current row data from the FormRow 


        currentRow.PayDetcode = response[0].pD_CODE
        currentRow.PayDetName = response[0].pD_DESC
        currentRow.PayDetFormat = response[0].pD_FORMAT
        currentRow.PayDetcodeDesable = true
        currentRow.ExpDateDisable = response[0].pD_REQDATE == 1 ? false : true
        currentRow.PayAmountDisable = false

        handleObjectChange(currentRow, FormRow.id)
    }

    const FormatNumbers = (txtFormat, value) => {

        // let format = txtFormat; // change this to your desired format
        // let inputValue = value.replace(0, "");
        // let formattedValue = "";

        // for (let i = 0; i < format.length; i++) {
        //     if (inputValue[i] && format[i] === "0") {
        //         formattedValue += inputValue[i];
        //     } else {
        //         formattedValue += format[i];
        //     }
        // }

        // return formattedValue;

        var s = "000000000" + value;
        return s.substr(s.length - txtFormat);


    }



    const GetSelectRowPayment = async (e, row, isSelect, rowIndex) => {

        if (CodeValidation(row.PH_CODE, FormRow.id, 1)) {
            GetPaymodeDetails(row.PH_CODE)
            setmodal_xlargePay(!modal_xlargePay)
        } else {
            changeRowValueChanges("", FormRow.id, "Paycode")
            setAlertDescription("Payment Code already used")
            setAlertConfirmOption(4)
            setsweetAlertShow(true)
        }
    }


    const GetSelectRowPayDet = (e, row, isSelect, rowIndex) => {

        const currentRow = FormRow

        // if (CodeValidation(Paycode, "txtPaycode" + Key, row.PD_CODE, "txtPaydetCode" + Key)) {

        GetPaymodeHedDetails(row.PD_CODE)


        setmodal_xlargePayDet(!modal_xlargePayDet)
        // } else {
        //     setAlertDescription("Payment Code already used")
        //     setAlertConfirmOption(4)
        //     setsweetAlertShow(true)
        // }
    }
    return (
        <tr key={FormRow.id}>
            <td>{Key + 1}</td>
            <td style={{ width: "110px" }}>
                <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    labelText="Code"
                    textType="text"
                    maxLength="10"
                    id={"txtPaycode" + Key}
                    value={FormRow.Paycode}
                    disabled={Disabled ? true : FormRow.PayCodeDisable}
                    onChange={e => {
                        //setPaycode(e.target.value)
                        changeRowValueChanges(e.target.value, FormRow.id, "Paycode")
                    }}
                    onBlur={e => {
                        if (CodeValidation(e.target.value, FormRow.id)) {
                            GetPaymodeDetails(e.target.value)
                        } else {
                            setAlertDescription("Payment Code already used")
                            setAlertConfirmOption(4)
                            setsweetAlertShow(true)
                        }
                    }}
                />
            </td>
            <td>
                <Button
                    outline
                    color="success"
                    disabled={Disabled ? true : FormRow.PayCodeDisable}
                    id={"btnPaySearch" + Key}
                    onClick={clickPaySearch}
                    size="sm"
                >
                    <i className="mdi mdi-search-web" style={{ fontSize: "12px" }}></i>
                </Button>
            </td>
            <td style={{ width: "200px" }}>
                <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    labelText="Code"
                    textType="text"
                    maxLength="8"
                    id={"txtPaydesc" + Key}
                    value={FormRow.Paydesc}
                    disabled={true}
                    onChange={e => {
                        changeRowValueChanges(e.target.value, FormRow.id, "Paydesc")
                    }}
                ></DPTextBoxforgrid>
            </td>
            <td style={{ width: "120px" }}>
                <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    labelText="Code"
                    textType="text"
                    maxLength="8"
                    id={"txtPaydetCode" + Key}
                    value={FormRow.PayDetcode}
                    disabled={Disabled ? true : FormRow.PayDetcodeDesable}
                    onChange={e => {
                        changeRowValueChanges(e.target.value, FormRow.id, "PayDetcode")

                    }}
                    onBlur={e => {
                        GetPaymodeHedDetails(e.target.value)
                    }}
                ></DPTextBoxforgrid>
            </td>
            <td>
                <Button
                    outline
                    color="success"
                    disabled={Disabled ? true : FormRow.PayDetcodeDesable}
                    id={"btnPayDetSearch" + Key}
                    onClick={clickPaySearchDet}
                    size="sm"
                >
                    <i className="mdi mdi-search-web" style={{ fontSize: "12px" }}></i>
                </Button>
            </td>
            <td style={{ width: "200px" }}>
                <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    labelText="Code"
                    textType="text"
                    maxLength="8"
                    id={"txtPayDetdesc" + Key}
                    value={FormRow.PayDetName}
                    disabled={true}
                    onChange={e => {
                        //setPayDetName(e.target.value)
                        changeRowValueChanges(e.target.value, FormRow.id, "PayDetName")
                    }}
                ></DPTextBoxforgrid>
            </td>
            <td style={{ width: "160px" }}>
                <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    labelText="Code"
                    textType="text"
                    maxLength="15"
                    id={"txtAccountCode" + Key}
                    value={FormRow.AccountCode}
                    placeholder={FormRow.PayDetFormat}
                    disabled={Disabled ? true : FormRow.AccountCodeDisable}
                    onChange={e => {

                        // var num1 = FormatNumbers(6, e.target.value)
                        var inputnum = Numeric(e.target, FormRow.PayDetFormat.length, 0, false)
                        var num = ""
                        if (inputnum.length > FormRow.PayDetFormat.length) {
                            num = inputnum.substring(0, FormRow.PayDetFormat.length)
                        } else {
                            num = inputnum
                        }


                        changeRowValueChanges(num, FormRow.id, "AccountCode")
                    }}
                    onBlur={e => {
                        CheckAccountNoLenth(FormRow.PayDetcode, e.target.value)
                    }}
                ></DPTextBoxforgrid>
            </td>
            <td style={{ width: "160px" }}>
                <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    labelText="Code"
                    textType="date"
                    maxLength="10"
                    id={"txtExpDate" + Key}
                    value={FormRow.ExpDate == "1900-01-01" ? "" : FormRow.ExpDate}
                    disabled={Disabled ? true : FormRow.ExpDateDisable}
                    onChange={e => {
                        //setReqDate(e.target.value)
                        changeRowValueChanges(e.target.value, FormRow.id, "ExpDate")
                    }}
                ></DPTextBoxforgrid>
            </td>
            <td style={{ width: "145px" }}>
                <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    labelText="Code"
                    textType="text"
                    textAlign="right"
                    disabled={Disabled ? true : FormRow.PayAmountDisable}
                    id={"txtPayAmount" + Key}
                    value={FormRow.PayAmount}
                    onChange={e => {
                        let valPayAmount = Numeric(e.target, 15, 2, false)
                        if (valPayAmount == "") {

                            changeRowValueChanges(0.0, FormRow.id, "PayAmount")
                        } else {
                            changeRowValueChanges(valPayAmount, FormRow.id, "PayAmount")
                        }
                    }}
                    onBlur={async (e) => {

                        let currentVal = DecimalValidation(e.target.value, 0, true, txnDecimalAmt)

                        await changeRowValueChanges(currentVal, FormRow.id, "PayAmount")
                        setTimeout(() => {
                            TotalPayCalculation()
                        }, 200);

                    }}
                    onKeyPress={async (e) => {
                        if (e.key === 'Enter') {
                            let currentVal = DecimalValidation(e.target.value, 0, true, txnDecimalAmt)

                            await changeRowValueChanges(currentVal, FormRow.id, "PayAmount")
                            setTimeout(() => {
                                TotalPayCalculation()
                            }, 200);
                        }
                    }}

                ></DPTextBoxforgrid>
            </td>

            <td>
                <Button
                    outline
                    disabled={Disabled}
                    color="danger"
                    onClick={e => {
                        RemoveRow(FormRow.id)
                    }}
                    size="sm"
                >
                    <i className="mdi mdi-delete" style={{ fontSize: "12px" }}></i>
                </Button>
            </td>

            <DPSearchBoxDynamic
                searchData={[]}
                columns={[]}
                mainTitle={"Payment Search"}
                SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                isOpen={modal_xlargePay}
                toggle={tog_xlargePay}
                getSelect={GetSelectRowPayment}
                APIURL={ApiURL}
                URLPath={"PAYMENT"}
                MenuCode={menuCode}
                KeyVal={"TXN"}
                searchBy={"PH_DESC"}
                FilterStr={groupFilter}
            />
            <DPSearchBoxDynamic
                searchData={[]}
                columns={[]}
                mainTitle={"Payment Detail Search"}
                SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                isOpen={modal_xlargePayDet}
                toggle={tog_xlargePayDet}
                getSelect={GetSelectRowPayDet}
                APIURL={ApiURL}
                URLPath={"PAYMENTDET"}
                MenuCode={menuCode}
                KeyVal={"TXN"}
                searchBy={"PD_DESC"}
                FilterStr={groupFilter}
            />
            <DPAlert
                confirm_both={sweetAlertShow}
                title={"Invoice !"}
                description={AlertDescription}
                showCancel={false}
                btnColor={"success"}
                cancelColor={"danger"}
                onConfirm={() => {
                    setsweetAlertShow(false)
                    //  setPaycode("")
                }}
                btnYes={"OK"}
            />
        </tr>
    )
}